import { render, staticRenderFns } from "./dialog-taxbox.vue?vue&type=template&id=d0840c58&"
import script from "./dialog-taxbox.vue?vue&type=script&lang=js&"
export * from "./dialog-taxbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports